// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import SurveyStepElement from "./survey-step-element.js"

const modelClassData = {
  "attributes": {
    "image_content_type": {
      "column": null,
      "name": "image_content_type",
      "selected_by_default": false,
      "translated": false
    },
    "image_url": {
      "column": null,
      "name": "image_url",
      "selected_by_default": false,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "font_awesome_icon": {
      "column": {
        "default": null,
        "name": "font_awesome_icon",
        "null": true,
        "type": "string"
      },
      "name": "font_awesome_icon",
      "selected_by_default": null,
      "translated": false
    },
    "hide_label": {
      "column": {
        "default": "0",
        "name": "hide_label",
        "null": false,
        "type": "boolean"
      },
      "name": "hide_label",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "position": {
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": false
    },
    "survey_step_element_id": {
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": false,
        "type": null
      },
      "name": "survey_step_element_id",
      "selected_by_default": null,
      "translated": false
    },
    "text_style": {
      "column": {
        "default": null,
        "name": "text_style",
        "null": true,
        "type": "text"
      },
      "name": "text_style",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "SurveyStepElementOption",
  "collectionKey": "survey_step_element_options",
  "collectionName": "survey_step_element_options",
  "i18nKey": "survey_step_element_option",
  "camelizedLower": "surveyStepElementOption",
  "name": "SurveyStepElementOption",
  "nameDasherized": "survey-step-element-option",
  "pluralName": "survey_step_element_options",
  "ransackable_associations": [
    {
      "className": "TeamSurveyStepElementAnswer",
      "collectionName": "team_survey_step_element_answers",
      "foreignKey": "survey_step_element_option_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "TeamSurveyStepElementAnswer",
      "through": null
    },
    {
      "className": "SurveyStepElementOption::Audit",
      "collectionName": "survey_step_element_option_audits",
      "foreignKey": "survey_step_element_option_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOption::Audit",
      "collectionName": "survey_step_element_option_audits",
      "foreignKey": "survey_step_element_option_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SurveyStepElementOptionAudit",
      "through": null
    },
    {
      "className": "SurveyStepElementOption::Translation",
      "collectionName": null,
      "foreignKey": "survey_step_element_option_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "image_attachment",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "image_blob",
      "macro": "has_one",
      "resource_name": null,
      "through": "image_attachment"
    },
    {
      "className": "SurveyStepElementOptionScore",
      "collectionName": "survey_step_element_option_scores",
      "foreignKey": "survey_step_element_option_id",
      "name": "scores",
      "macro": "has_many",
      "resource_name": "SurveyStepElementOptionScore",
      "through": null
    },
    {
      "className": "SurveyStep",
      "collectionName": "survey_steps",
      "foreignKey": "survey_step_id",
      "name": "step",
      "macro": "has_one",
      "resource_name": "SurveyStep",
      "through": "element"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "has_one",
      "resource_name": "Survey",
      "through": "step"
    },
    {
      "className": "SurveyStepElementOption::Translation",
      "collectionName": null,
      "foreignKey": "survey_step_element_option_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "font_awesome_icon",
      "column": {
        "default": null,
        "name": "font_awesome_icon",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "hide_label",
      "column": {
        "default": "0",
        "name": "hide_label",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "survey_step_element_id",
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "text_style",
      "column": {
        "default": null,
        "name": "text_style",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    }
  ],
  "paramKey": "survey_step_element_option",
  "primaryKey": "id"
}

/** Frontend model for SurveyStepElementOption. */
export default class SurveyStepElementOption extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  imageContentType() {
    return this.readAttributeUnderscore("image_content_type")
  }

  /** @returns {boolean} */
  hasImageContentType() {
    const value = this.imageContentType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  imageUrl() {
    return this.readAttributeUnderscore("image_url")
  }

  /** @returns {boolean} */
  hasImageUrl() {
    const value = this.imageUrl()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  fontAwesomeIcon() {
    return this.readAttributeUnderscore("font_awesome_icon")
  }

  /** @returns {boolean} */
  hasFontAwesomeIcon() {
    const value = this.fontAwesomeIcon()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  hideLabel() {
    return this.readAttributeUnderscore("hide_label")
  }

  /** @returns {boolean} */
  hasHideLabel() {
    const value = this.hideLabel()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyStepElementId() {
    return this.readAttributeUnderscore("survey_step_element_id")
  }

  /** @returns {boolean} */
  hasSurveyStepElementId() {
    const value = this.surveyStepElementId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  textStyle() {
    return this.readAttributeUnderscore("text_style")
  }

  /** @returns {boolean} */
  hasTextStyle() {
    const value = this.textStyle()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /** @returns {import("./survey-step-element.js").default | null} */
  element() {
    return this._readBelongsToReflection({modelClass: SurveyStepElement, reflectionName: "element"})
  }

  /** @returns {Promise<import("./survey-step-element.js").default | null>} */
  loadElement() {
    if (!("surveyStepElementId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepElementId")

    const id = this.surveyStepElementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "element",
        model: this,
        modelClass: SurveyStepElement
      },
      {ransack}
    )
  }
}
